'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = undefined;
exports.observerStart = observerStart;
exports.default = initSimpleImg;
exports.onIntersection = onIntersection;

var _imageLoader = require('./utils/imageLoader');

var _imageLoader2 = _interopRequireDefault(_imageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultConfig = exports.defaultConfig = {
  rootMargin: '0px 0px',
  threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
};
function observerStart() {
  var _this = this;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;

  /* eslint-disable */
  if (!window.IntersectionObserver) require('intersection-observer');
  // $FlowIgnoreLine:
  var observer = new IntersectionObserver(function (entries) {
    return onIntersection.call(_this, entries);
  }, config);
  if (this) {
    return observer;
  } else {
    window.__REACT_SIMPLE_IMG__ = {
      observer: observer,
      imgLoadingRefs: new Map()
    };
  }
  return;
  /* eslint-enable */
}

function initSimpleImg() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;

  if (typeof window === 'undefined') return;
  /* eslint-disable */
  window.addEventListener('load', function () {
    observerStart(config);
  });
  /* eslint-enable */
}

function onIntersection(entries) {
  for (var i = 0, len = entries.length; i < len; i++) {
    // eslint-disable-line no-plusplus
    var _entries$i = entries[i],
        _intersectionRatio = _entries$i.intersectionRatio,
        _target = _entries$i.target;

    if (_intersectionRatio > 0) {
      _imageLoader2.default.call(this, _target);
    }
  }
}